module.exports = __webpack_public_path__ + "img/icon_002.daef53c.webp";